<template>
  <v-container id="sign-up" class="d-flex flex-column" fluid>
    <v-container>
      <v-layout row wrap align-center>
        <v-flex>
          <v-form
            v-model="valid"
            ref="form"
            :lazy-validation="false"
            class="auth-form text-left px-md-8 px-sm-2"
            @submit.prevent="submit"
          >
            <v-row class="justify-center">
              <v-col sm="12" class="pb-0">
                <v-alert
                  class="error"
                  id="error"
                  type="info"
                  dense
                  icon="mdi-information-outline"
                  v-if="errorSummary !== null"
                >
                  {{ errorSummary }}
                </v-alert>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <label class="font-weight-bold subtitle-2">{{ $t('institution') }}</label>
                <v-autocomplete
                  v-if="!isNotListedHostingInstitution"
                  v-model.trim="user.institutionText"
                  :items="researcherInstitutions"
                  :placeholder="$t('institution')"
                  item-text="name"
                  outlined
                  return-object
                  clearable
                  :rules="requiredRule()"
                  no-data-text="Press enter button to add a new institution."
                  class="required"
                  @keyup.enter="addInstitutionTag"
                  @update:search-input="typedInstitution = $event"
                />
                <v-text-field
                  v-if="isNotListedHostingInstitution"
                  v-model.trim="user.institutionText"
                  :placeholder="'Type the hosting institution you want, which is not listed.'"
                  type="text"
                  outlined
                  :rules="requiredRule()"
                  class="required"
                  clearable
                  @click:clear="clearInstitutionText"
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <v-btn
                  type="submit"
                  color="neutral"
                  :loading="loading"
                  :disabled="loading || !valid"
                  data-cy="login"
                  depressed
                  block
                  large
                  rounded
                  class="white--text mb-6 mt-10 font-weight-bold"
                >
                  {{ $t('submit') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import Vue from 'vue';
import EventBus from '@/helpers/event-bus';

export default {
  name: 'FirstLogin',
  mixins: [util],
  data: () => ({
    loading: false,
    valid: false,
    user: {
      institutionText: null,
    },
    researcherInstitutions: [],
    isNotListedHostingInstitution: false,
    typedInstitution: '',
    errorSummary: null,
  }),
  mounted() {
    this.axios
      .get('/api/v1/hosting-institutions/researcher/by-name?name=')
      .then(res => {
        this.researcherInstitutions = res.data.content;
      })
      .catch(error => {
        this.errorSummary = error.response?.data || error.message;
      });
  },
  methods: {
    addInstitutionTag() {
      const selectedInstitution = this.user.institutionText || this.typedInstitution?.trim();
      const exists = this.researcherInstitutions.some(inst => inst.name === selectedInstitution);

      if (!exists && selectedInstitution) {
        this.user.institutionText = selectedInstitution;
        this.isNotListedHostingInstitution = true;
      }
    },
    clearInstitutionText() {
      this.isNotListedHostingInstitution = false;
      this.user.institutionText = null;
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.errorSummary = null;
      this.axios
        .post('/api/v1/auth/first-login', this.user)
        .then(() => {
          this.clearLocalStorage();
          const basePath = window.location.origin.toString();
          Vue.$keycloak.login({ redirectUri: basePath + '/app/dashboard' });
        })
        .catch(error => {
          console.log(error);
          this.errorSummary = error.response.data;
          if (error.response && error.response.status === 409) {
            EventBus.$emit('snackbar', {
              text: error.response.data,
              color: 'error',
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
